(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fz-cases"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-cases-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    class FzCases extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fz-cases__track');
        this.viewport = this.querySelector('.fz-cases__viewport');
        if (!this.track) return;
        this.raf = 0;

        this.update = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const t = this.track;
            const max = t.scrollWidth - t.clientWidth;
            this.style.setProperty('--thumb', Math.min(1, t.clientWidth / Math.max(1, t.scrollWidth)).toFixed(4));
            this.style.setProperty('--pos', max > 0 ? (t.scrollLeft / max).toFixed(4) : '0');
            if (!reduce.matches) {
              const r = this.getBoundingClientRect();
              const vh = window.innerHeight;
              const p = (vh - r.top) / (vh + r.height);
              this.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
            }
          });
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        document.addEventListener('scroll', this.update, { passive: true, capture: true });
        window.addEventListener('resize', this.update);
        this.update();

        if (fine.matches && !reduce.matches) this.setupDrag();
      }

      setupDrag() {
        const t = this.track;
        let down = false;
        let moved = false;
        let startX = 0;
        let startLeft = 0;

        this.onMove = (e) => {
          const r = this.viewport.getBoundingClientRect();
          this.style.setProperty('--cx', `${e.clientX - r.left}px`);
          this.style.setProperty('--cy', `${e.clientY - r.top}px`);
          if (!down) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          t.scrollLeft = startLeft - dx;
        };
        this.onDown = (e) => {
          if (e.button !== 0) return;
          down = true;
          moved = false;
          startX = e.clientX;
          startLeft = t.scrollLeft;
          t.classList.add('is-dragging');
        };
        this.onUp = () => {
          if (!down) return;
          down = false;
          t.classList.remove('is-dragging');
        };
        this.onClick = (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        };

        t.addEventListener('pointerenter', () => this.classList.add('is-hover'));
        t.addEventListener('pointerleave', () => {
          this.classList.remove('is-hover');
          this.onUp();
        });
        t.addEventListener('pointerdown', this.onDown);
        t.addEventListener('click', this.onClick, true);
        t.addEventListener('dragstart', (e) => e.preventDefault());
        this.viewport.addEventListener('pointermove', this.onMove);
        window.addEventListener('pointerup', this.onUp);
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.update, true);
        window.removeEventListener('resize', this.update);
        if (this.onUp) window.removeEventListener('pointerup', this.onUp);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-cases-el', FzCases);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-cta"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-cta-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzCta extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.raf = 0;
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const r = this.getBoundingClientRect();
            const vh = window.innerHeight;
            const p = (vh - r.top) / (vh + r.height);
            this.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
          });
        };
        this.io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) {
            document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
            this.onScroll();
          } else {
            document.removeEventListener('scroll', this.onScroll, true);
          }
        });
        this.io.observe(this);
      }

      disconnectedCallback() {
        this.io?.disconnect();
        document.removeEventListener('scroll', this.onScroll, true);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-cta-el', FzCta);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-grid"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-grid-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzGrid extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        const items = this.querySelectorAll('.fz-gi');
        items.forEach((el, i) => el.style.setProperty('--i', i));
        this.setAttribute('data-js', '');
        this.io = new IntersectionObserver(
          (entries) => {
            for (const e of entries) {
              if (e.isIntersecting) {
                e.target.setAttribute('data-in', '');
                this.io.unobserve(e.target);
              }
            }
          },
          { rootMargin: '0px 0px -12% 0px' }
        );
        items.forEach((el) => this.io.observe(el));
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }
    }

    customElements.define('fz-grid-el', FzGrid);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-hero"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-hero-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzHero extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.raf = 0;
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const r = this.getBoundingClientRect();
            if (r.bottom < 0) return;
            const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
            this.style.setProperty('--p', p.toFixed(4));
          });
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-hero-el', FzHero);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-letter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-letter-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzLetter extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.raf = 0;
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const r = this.getBoundingClientRect();
            const vh = window.innerHeight;
            const p = (vh - r.top) / (vh + r.height);
            this.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
          });
        };
        this.io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) {
            document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
            this.onScroll();
          } else {
            document.removeEventListener('scroll', this.onScroll, true);
          }
        });
        this.io.observe(this);
      }

      disconnectedCallback() {
        this.io?.disconnect();
        document.removeEventListener('scroll', this.onScroll, true);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-letter-el', FzLetter);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-process"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-process-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzProcess extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        const steps = this.querySelectorAll('.fz-step');
        steps.forEach((el, i) => el.style.setProperty('--i', i % 2));
        this.setAttribute('data-js', '');
        this.io = new IntersectionObserver(
          (entries) => {
            for (const e of entries) {
              if (e.isIntersecting) {
                e.target.setAttribute('data-in', '');
                this.io.unobserve(e.target);
              }
            }
          },
          { rootMargin: '0px 0px -18% 0px' }
        );
        steps.forEach((el) => this.io.observe(el));
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }
    }

    customElements.define('fz-process-el', FzProcess);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-quote"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-quote-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzQuote extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.raf = 0;
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const r = this.getBoundingClientRect();
            const vh = window.innerHeight;
            const p = (vh - r.top) / (vh + r.height);
            this.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
          });
        };
        this.io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) {
            document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
            this.onScroll();
          } else {
            document.removeEventListener('scroll', this.onScroll, true);
          }
        });
        this.io.observe(this);
      }

      disconnectedCallback() {
        this.io?.disconnect();
        document.removeEventListener('scroll', this.onScroll, true);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-quote-el', FzQuote);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-services"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-services-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzServices extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.raf = 0;
        this.panels = [...this.querySelectorAll('.fz-svi')];
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const vh = window.innerHeight;
            for (const el of this.panels) {
              const r = el.getBoundingClientRect();
              if (r.bottom < -vh * 0.2 || r.top > vh * 1.2) continue;
              const center = r.top + r.height / 2;
              const q = 1 - Math.min(1, Math.abs(center - vh * 0.5) / (vh * 0.62));
              el.style.setProperty('--q', Math.max(0, q).toFixed(4));
            }
          });
        };
        this.io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) {
            document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
            this.onScroll();
          } else {
            document.removeEventListener('scroll', this.onScroll, true);
          }
        });
        this.io.observe(this);
        this.setAttribute('data-js', '');
        this.onScroll();
      }

      disconnectedCallback() {
        this.io?.disconnect();
        document.removeEventListener('scroll', this.onScroll, true);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-services-el', FzServices);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-statement"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-statement-el')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FzStatement extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.setAttribute('data-js', '');
        this.head = this.querySelector('.fz-st__title');
        this.raf = 0;
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const r = this.head.getBoundingClientRect();
            const vh = window.innerHeight;
            const p = (vh * 0.92 - r.top) / (vh * 0.62);
            this.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
          });
        };
        this.io = new IntersectionObserver(
          (entries) => {
            for (const e of entries) {
              if (e.isIntersecting) {
                this.setAttribute('data-in', '');
                document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
                this.onScroll();
              } else {
                document.removeEventListener('scroll', this.onScroll, true);
              }
            }
          },
          { rootMargin: '0px 0px -15% 0px' }
        );
        this.io.observe(this);
        this.onScroll();
      }

      disconnectedCallback() {
        this.io?.disconnect();
        document.removeEventListener('scroll', this.onScroll, true);
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('fz-statement-el', FzStatement);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fz-tema"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('fz-cursor-el')) return;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const LINK = 'a, button, [role="button"], input, select, textarea, label, summary';

    class FzCursor extends HTMLElement {
      connectedCallback() {
        if (!fine.matches || reduce.matches) return;
        /* Fuera del pie para quedar por encima de la cabecera y de cualquier capa */
        if (!(window.Shopify && window.Shopify.designMode) && this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (this.running) return;
        this.running = true;
        let x = -100;
        let y = -100;
        let lastTone = 0;

        const paint = () => {
          this.frame = 0;
          this.style.setProperty('--x', `${x}px`);
          this.style.setProperty('--y', `${y}px`);
          const now = performance.now();
          if (now - lastTone > 80) {
            lastTone = now;
            this.updateTone(x, y);
          }
        };

        this.onMove = (e) => {
          x = e.clientX;
          y = e.clientY;
          this.classList.remove('is-hidden');
          if (!this.frame) this.frame = requestAnimationFrame(paint);
        };
        this.onOver = (e) => {
          const t = e.target instanceof Element ? e.target : null;
          if (!t) return;
          this.classList.toggle('is-link', !!t.closest(LINK));
          this.classList.toggle('is-off', !!t.closest('.fz-cases__track, [data-fz-cursor="ocultar"]'));
        };
        this.onLeave = () => this.classList.add('is-hidden');

        window.addEventListener('pointermove', this.onMove, { passive: true });
        document.addEventListener('pointerover', this.onOver, { passive: true });
        document.documentElement.addEventListener('pointerleave', this.onLeave);
        if (this.hasAttribute('data-sin-flecha')) document.documentElement.classList.add('fz-sin-flecha');
      }

      /* Elige punto claro u oscuro según lo que hay debajo, también bajo la cabecera */
      updateTone(x, y) {
        let tone = 'claro';
        for (const el of document.elementsFromPoint(x, y)) {
          if (el === this || this.contains(el)) continue;
          const tonal = el.closest('[data-tono]');
          if (tonal && !el.closest('#header-component')) {
            tone = tonal.getAttribute('data-tono');
            break;
          }
          const bg = getComputedStyle(el).backgroundColor;
          const m = bg.match(/rgba?\(([\d.]+)[, ]+([\d.]+)[, ]+([\d.]+)(?:[, /]+([\d.]+))?/);
          if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)) {
            const lum = 0.299 * m[1] + 0.587 * m[2] + 0.114 * m[3];
            tone = lum < 128 ? 'oscuro' : 'claro';
            break;
          }
        }
        this.dataset.tone = tone;
      }

      disconnectedCallback() {
        if (!this.running) return;
        this.running = false;
        document.documentElement.classList.remove('fz-sin-flecha');
        cancelAnimationFrame(this.frame);
        window.removeEventListener('pointermove', this.onMove);
        document.removeEventListener('pointerover', this.onOver);
        document.documentElement.removeEventListener('pointerleave', this.onLeave);
      }
    }

    customElements.define('fz-cursor-el', FzCursor);
  })();
  } catch(e) { console.error(e); }
})();

})();
